import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { EVENT_MATERIALS_ACTIONS, EVENT_MATERIALS_TYPES } from "./actions";
import {
  getEventMaterial as APIgetEventMaterial,
  getEventMaterials as APIgetEventMaterials,
  createEventMaterial as APIcreateEventMaterial,
  updateEventMaterial as APIupdateEventMaterial,
  deleteEventMaterial as APIdeleteEventMaterial
} from "../../services/api/eventMaterials";
import { navigateTo } from "../navigation/saga";
import { eventMaterialsFilters, eventMaterialsEvent } from "./selectors";

export function* watchEventMaterialsActions() {
  yield all([
    takeEvery(EVENT_MATERIALS_TYPES.LOAD_ALL_REQUEST, getEventMaterials)
  ]);
  yield all([takeEvery(EVENT_MATERIALS_TYPES.LOAD_REQUEST, getEventMaterial)]);
  yield all([
    takeEvery(EVENT_MATERIALS_TYPES.CREATE_REQUEST, createEventMaterial)
  ]);
  yield all([
    takeEvery(EVENT_MATERIALS_TYPES.UPDATE_REQUEST, updateEventMaterial)
  ]);
  yield all([
    takeEvery(EVENT_MATERIALS_TYPES.DELETE_REQUEST, deleteEventMaterial)
  ]);
  yield all([
    takeEvery(EVENT_MATERIALS_TYPES.CREATE_SUCCESS, getEventMaterials)
  ]);
  yield all([
    takeEvery(EVENT_MATERIALS_TYPES.DELETE_SUCCESS, getEventMaterials)
  ]);
}

function* getEventMaterials(action) {
  let { filters } = action.payload;

  try {
    if (filters) {
      yield put(EVENT_MATERIALS_ACTIONS.updateFilters(filters));
    } else {
      filters = yield select(eventMaterialsFilters);
    }
    const eventId = yield call(checkEventId, action.payload.eventId);
    const eventMaterials = yield call(APIgetEventMaterials, eventId, filters);
    yield put(EVENT_MATERIALS_ACTIONS.loadAllSuccess(eventMaterials));
  } catch (e) {
    yield put(EVENT_MATERIALS_ACTIONS.loadAllFailure(e));
  }
}

function* getEventMaterial(action) {
  const { id, filters } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const eventMaterial = yield call(APIgetEventMaterial, eventId, id, filters);
    yield put(EVENT_MATERIALS_ACTIONS.loadSuccess(eventMaterial));
  } catch (e) {
    yield put(EVENT_MATERIALS_ACTIONS.loadFailure(e));
  }
}

function* createEventMaterial(action) {
  const { values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const eventMaterial = yield call(APIcreateEventMaterial, eventId, values);
    yield put(EVENT_MATERIALS_ACTIONS.createSuccess(eventMaterial));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/material-requests"
    );
  } catch (e) {
    yield put(EVENT_MATERIALS_ACTIONS.createFailure(e));
  }
}

function* updateEventMaterial(action) {
  const { id, values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const eventMaterial = yield call(
      APIupdateEventMaterial,
      eventId,
      id,
      values
    );
    yield put(EVENT_MATERIALS_ACTIONS.updateSuccess(eventMaterial));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/material-requests"
    );
  } catch (e) {
    yield put(EVENT_MATERIALS_ACTIONS.updateFailure(e));
  }
}

function* deleteEventMaterial(action) {
  const { id } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const eventMaterial = yield call(APIdeleteEventMaterial, eventId, id);
    yield put(EVENT_MATERIALS_ACTIONS.deleteSuccess(eventMaterial));
  } catch (e) {
    yield put(EVENT_MATERIALS_ACTIONS.deleteFailure(e));
  }
}

function* checkEventId(eventId) {
  if (eventId) {
    yield put(EVENT_MATERIALS_ACTIONS.updateEvent(eventId));
  } else {
    eventId = yield select(eventMaterialsEvent);
  }

  return eventId;
}
